import * as React from "react"
import { LabelContext } from "../../core/label.context"
import { UserContext } from "../../core/user.context"
import { InputElement } from "../input/input.component"
import { Box } from "../box/box.component"
import { Button } from "../button/button.component"
import { useForm, SubmitHandler } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { inputMaxLength, regexPwdValidation } from "../../common/constants"

export const ChangePasswordBox = ({ callback }: { callback: () => void }) => {
    const { t } = React.useContext(LabelContext)
    const { changePwdCustomer } = React.useContext(UserContext)

    const schema = yup.object().shape({
        oldpassword: yup.string().max(inputMaxLength).required(t("ecommerce.form-messagge.required")),
        newpassword: yup
            .string()
            .max(inputMaxLength)
            .required(t("ecommerce.form-messagge.required"))
            .trim()
            .matches(regexPwdValidation, t("ecommerce.form-messagge.password-invalid")),
        newpassword_check: yup
            .string()
            .max(inputMaxLength)
            .oneOf([yup.ref("newpassword")], t("ecommerce.form-messagge.password-must-match"))
            .required(t("ecommerce.form-messagge.required")),
    })

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    })

    const onSubmit: SubmitHandler<any> = (data) => {
        changePwdCustomer(data)
        callback() // torni a "none" nel parent
    }

    return (
        <Box className="secondary">
            <form onSubmit={handleSubmit(onSubmit)}>
                <h3>{t("ecommerce.myaccount.changepassword-form-title")}</h3>
                <InputElement
                    externalRegister={register("oldpassword")}
                    id="oldpassword"
                    type="password"
                    className="col-9"
                    label={t("ecommerce.myaccount.changepassword-old-password-field")}
                    errors={errors.oldpassword?.message}
                />
                <InputElement
                    externalRegister={register("newpassword")}
                    id="newpassword"
                    type="password"
                    className="col-9"
                    label={t("ecommerce.myaccount.changepassword-new-password-field")}
                    errors={errors.newpassword?.message}
                />
                <InputElement
                    externalRegister={register("newpassword_check")}
                    id="newpassword_check"
                    type="password"
                    className="col-9"
                    label={t("ecommerce.myaccount.changepassword-old-password-confirm-field")}
                    errors={errors.newpassword_check?.message}
                />
                <div className="row">
                    <div className="col-md-3 offset-md-1">
                        <Button
                            className="primary actionForm"
                            label={t("ecommerce.common.save")}
                            type="submit"
                        />
                    </div>
                    <div className="col-md-3 offset-md-1">
                        <Button
                            className="secondary actionForm"
                            label={t("ecommerce.common.cancel")}
                            type="button"
                            onClick={callback}
                        />
                    </div>
                </div>
            </form>
        </Box>
    )
}
